import { render } from "./filter.svg?vue&type=template&id=00d54685"
const script = {}
script.render = render

export default script